var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99897 12.3139C8.87727 12.3139 11.2106 9.98054 11.2106 7.10224C11.2106 4.22395 8.87727 1.89062 5.99897 1.89062C3.12068 1.89062 0.787354 4.22395 0.787354 7.10224C0.787354 9.98054 3.12068 12.3139 5.99897 12.3139Z",
    fill: "#7F23F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99889 10.8542C8.07103 10.8542 9.75083 9.17442 9.75083 7.10228C9.75083 5.03014 8.07103 3.35034 5.99889 3.35034C3.92675 3.35034 2.24695 5.03014 2.24695 7.10228C2.24695 9.17442 3.92675 10.8542 5.99889 10.8542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57321 0.839941C2.71096 0.132347 1.44195 0.170481 0.636905 0.975528C-0.168142 1.78057 -0.206276 3.04958 0.501318 3.91183L3.57321 0.839941Z",
    fill: "#FFDA01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 0.839941C9.28901 0.132347 10.558 0.170481 11.3631 0.975528C12.1681 1.78057 12.2062 3.04958 11.4986 3.91183L8.42676 0.839941Z",
    fill: "#FFDA01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9989 7.51977C6.22939 7.51977 6.41625 7.33291 6.41625 7.10241C6.41625 6.87191 6.22939 6.68506 5.9989 6.68506C5.7684 6.68506 5.58154 6.87191 5.58154 7.10241C5.58154 7.33291 5.7684 7.51977 5.9989 7.51977Z",
    fill: "#14945C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41626 7.10254H8.14287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9989 6.68487V4.11084",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimer);
export default __webpack_public_path__ + "static/media/icon_timer.692f95ca78c8531318fcf48acb0e4272.svg";
export { ForwardRef as ReactComponent };